
import { Component, Prop, Vue } from 'vue-property-decorator';
import { InlineResponse200, InlineResponse200Totals } from '@/api';

@Component({})
export default class ContainerCalculationTotals extends Vue {
  @Prop({ type: String, default: 'select-products' })
  mod!: string;

  get result(): InlineResponse200 {
    return this.$store.state.container.result;
  }

  get status(): string {
    return this.$store.getters['container/status'];
  }

  get totals(): InlineResponse200Totals | undefined {
    return this.result?.Totals;
  }

  get grossWeight(): number | undefined {
    return this.totals?.WeightLoading;
  }

  get boxes(): number | undefined {
    return this.totals?.NumBoxes;
  }

  get pallets(): number | undefined {
    return this.totals?.NumPallets;
  }
}
